import React from 'react'
import ReactDOM from 'react-dom'
import Wordlist from './WordlistContainer'

function makeJQueryPlugin($) {
  $.fn.wordlist = function() {
    this.each(function() {
      let data = $(this).data()
      let props = Object.assign({}, data.props)
      ReactDOM.render(<Wordlist {...props} />, this)
    })
    return this
  }
}

export default makeJQueryPlugin
